import { createFeatureSelector, createSelector } from '@ngrx/store';
import { extensionDetailFeatureKey, ExtensionDetailState } from './extension-detail.reducer';

export const extensionDetailFeature = createFeatureSelector<ExtensionDetailState>(extensionDetailFeatureKey);

export const getExtension = createSelector(extensionDetailFeature, (state) => {
   if (state.selectedExtensionId != null) {
      return state.entities[state.selectedExtensionId] ?? null;
   }
   return null;
});

export const getExtensionCallState = createSelector(extensionDetailFeature, (state) => {
   return state.callState;
});

export const getHackedFraudDetails = createSelector(extensionDetailFeature, (state) => {
   return state.hackedFraudDetails;
});

export const getExtensionAccountId = createSelector(extensionDetailFeature, (state) => {
   return state.extension?.accountId;
});

export const getExtensionNumbers = createSelector(extensionDetailFeature, (state) => {
   return state.accountExtensions;
});

export const getExternalNumbers = createSelector(extensionDetailFeature, (state) => {
   return state.externalNumbers;
});
